import React from 'react';
import { Table } from 'antd';
import styles from './ContactUploadModal.module.css';

const columns = [
  { title: 'Row', dataIndex: 'rowNumber', key: 'rowNumber', width: 60 },
  { title: 'Email', dataIndex: 'contactEmail', key: 'contactEmail' },
  { title: 'Reason', dataIndex: 'reason', key: 'reason' },
];

export const ContactPreviewTable = ({ errors }) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  const dataSource = errors.map((error, index) => ({ ...error, key: `${error.rowNumber}-${index}` }));

  return (
    <div className={styles['err-scroll']}>
      <Table
        size="small"
        bordered
        pagination={false}
        columns={columns}
        dataSource={dataSource}
      />
    </div>
  );
};
